import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { X, Sparkles } from "lucide-react";
import { useLocation } from "react-router-dom";

export default function AnnouncementPopup() {
  const [ann, setAnn] = useState(null);
  const [visible, setVisible] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    if (loc.pathname !== "/") return;
    api.get("/announcement").then((r) => {
      if (r.data) {
        setAnn(r.data);
        const dismissedId = sessionStorage.getItem("tara_ann_dismissed");
        if (dismissedId !== r.data.id) {
          setTimeout(() => setVisible(true), 1500);
        }
      }
    }).catch(() => {});
  }, [loc.pathname]);

  if (!ann || !visible) return null;

  const close = () => {
    setVisible(false);
    sessionStorage.setItem("tara_ann_dismissed", ann.id);
  };

  return (
    <div className="fixed inset-0 z-[100] bg-black/70 backdrop-blur-sm flex items-end md:items-center justify-center p-4 animate-in fade-in" data-testid="announcement-popup">
      <div className="bg-white max-w-lg w-full relative border-l-8 border-[#E65C00] shadow-2xl">
        <button
          onClick={close}
          className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center hover:bg-[#1A1A1A] hover:text-white transition-colors"
          aria-label="Close announcement"
          data-testid="announcement-close"
        >
          <X className="w-5 h-5" />
        </button>
        {ann.image && (
          <div className="h-44 overflow-hidden bg-[#1A1A1A]">
            <img src={ann.image} alt={ann.title} className="w-full h-full object-cover" />
          </div>
        )}
        <div className="p-7">
          <div className="inline-flex items-center gap-2 bg-[#FFCC00] text-[#1A1A1A] px-3 py-1 mb-4">
            <Sparkles className="w-3.5 h-3.5" />
            <span className="text-xs font-black uppercase tracking-widest">Special Offer</span>
          </div>
          <h3 className="font-heading text-2xl font-black uppercase leading-tight" data-testid="announcement-title">{ann.title}</h3>
          <p className="mt-3 text-gray-700 leading-relaxed">{ann.message}</p>
          {ann.cta_text && ann.cta_link && (
            <a href={ann.cta_link} onClick={close} className="btn-primary mt-6 inline-flex" data-testid="announcement-cta">
              {ann.cta_text}
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
